'use client';

import { c as _c } from "react/compiler-runtime";
import SlidersSimpleIcon from '@eversports/design-tokens/assets/icons/regular/sliders-simple.svg?icon';
import { cn } from '@eversports/klimt-design-components/tailwind/utils';
import Button from '@eversports/klimt-primitives/Button';
import { useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { Sheet, SheetTrigger } from '../../../../../../../../components/Sheet';
import { FILTER_KEY_URL_PARAMS, FILTER_TYPE } from '../Filters.types';
import type { UpdateFiltersProps } from './AdditionalFilters';
import FilterSheetContent from './FilterSheetContent';
import FilterSheetGroup from './FilterSheetGroup';
interface Props {
  selectedFilters: { [key in FILTER_TYPE]: Array<string> };
  resetFilter: (type: FILTER_TYPE) => () => void;
  resetAllFilters: () => void;
  handleApply: () => void;
  updateFilters: (values: UpdateFiltersProps) => () => void;
  undoFilterSelection: () => void;
}
const FiltersSheet = t0 => {
  const $ = _c(54);
  const {
    selectedFilters,
    handleApply,
    updateFilters,
    resetFilter,
    resetAllFilters,
    undoFilterSelection
  } = t0;
  const t = useTranslations("discover-sport-city");
  const [isOpen, setIsOpen] = useState(false);
  const searchParams = useSearchParams();
  let activeFiltersInSheet;
  if ($[0] !== searchParams) {
    const params = new URLSearchParams(searchParams.toString());
    activeFiltersInSheet = new Set(params.keys());
    activeFiltersInSheet.delete(FILTER_KEY_URL_PARAMS.DATE);
    activeFiltersInSheet.delete(FILTER_KEY_URL_PARAMS.START_TIME);
    $[0] = searchParams;
    $[1] = activeFiltersInSheet;
  } else {
    activeFiltersInSheet = $[1];
  }
  const activeFiltersInSheetCount = activeFiltersInSheet.size;
  const hasActiveFilters = activeFiltersInSheetCount > 0;
  let t1;
  if ($[2] !== isOpen || $[3] !== undoFilterSelection) {
    t1 = () => {
      setIsOpen(!isOpen);
      undoFilterSelection();
    };
    $[2] = isOpen;
    $[3] = undoFilterSelection;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const toggleSheet = t1;
  let t2;
  if ($[5] !== handleApply || $[6] !== toggleSheet) {
    t2 = () => {
      handleApply();
      toggleSheet();
    };
    $[5] = handleApply;
    $[6] = toggleSheet;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleClick = t2;
  let t3;
  if ($[8] !== resetAllFilters || $[9] !== toggleSheet) {
    t3 = () => {
      resetAllFilters();
      toggleSheet();
    };
    $[8] = resetAllFilters;
    $[9] = toggleSheet;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const handleResetAll = t3;
  const t4 = hasActiveFilters ? "tertiary-selected" : "tertiary";
  const t5 = hasActiveFilters ? "text-text-brand-primary" : "text-text-secondary";
  let t6;
  if ($[11] !== t5) {
    t6 = cn("size-2", t5);
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <SlidersSimpleIcon className={t6} aria-hidden={true} />;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("filters");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t4 || $[18] !== t7 || $[19] !== t8) {
    t9 = <Button size="sm" variant={t4} className="flex items-center gap-1">{t7}{t8}</Button>;
    $[17] = t4;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== activeFiltersInSheetCount || $[22] !== hasActiveFilters) {
    t10 = hasActiveFilters && <div className="absolute top-[-4px] right-[-4px] rounded-lg bg-surface-brand-selected px-[6px] text-xs font-medium text-white">{activeFiltersInSheetCount}</div>;
    $[21] = activeFiltersInSheetCount;
    $[22] = hasActiveFilters;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t9) {
    t11 = <SheetTrigger asChild={true} className="sm:hidden"><div className="relative">{t9}{t10}</div></SheetTrigger>;
    $[24] = t10;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  const t12 = selectedFilters[FILTER_TYPE.LOCATION_OFFERING];
  let t13;
  if ($[27] !== resetFilter || $[28] !== t12 || $[29] !== updateFilters) {
    t13 = <FilterSheetGroup filterType={FILTER_TYPE.LOCATION_OFFERING} activeFilters={t12} updateFilters={updateFilters} resetFilter={resetFilter} />;
    $[27] = resetFilter;
    $[28] = t12;
    $[29] = updateFilters;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const t14 = selectedFilters[FILTER_TYPE.LEVEL];
  let t15;
  if ($[31] !== resetFilter || $[32] !== t14 || $[33] !== updateFilters) {
    t15 = <FilterSheetGroup filterType={FILTER_TYPE.LEVEL} activeFilters={t14} updateFilters={updateFilters} resetFilter={resetFilter} />;
    $[31] = resetFilter;
    $[32] = t14;
    $[33] = updateFilters;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t13 || $[36] !== t15) {
    t16 = <div className="flex flex-col gap-4">{t13}{t15}</div>;
    $[35] = t13;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t) {
    t17 = t("apply-changes");
    $[38] = t;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== handleClick || $[41] !== t17) {
    t18 = <Button onClick={handleClick} className="w-full">{t17}</Button>;
    $[40] = handleClick;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t16 || $[44] !== t18) {
    t19 = <div className="flex h-full flex-col items-center justify-between gap-2">{t16}{t18}</div>;
    $[43] = t16;
    $[44] = t18;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== handleResetAll || $[47] !== t19) {
    t20 = <FilterSheetContent reset={handleResetAll}>{t19}</FilterSheetContent>;
    $[46] = handleResetAll;
    $[47] = t19;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== isOpen || $[50] !== t11 || $[51] !== t20 || $[52] !== toggleSheet) {
    t21 = <Sheet open={isOpen} onOpenChange={toggleSheet}>{t11}{t20}</Sheet>;
    $[49] = isOpen;
    $[50] = t11;
    $[51] = t20;
    $[52] = toggleSheet;
    $[53] = t21;
  } else {
    t21 = $[53];
  }
  return t21;
};
export default FiltersSheet;